module.exports = __webpack_public_path__ + "media/images/home-hero-sm-95e233ad3791a93f816bad50ad6381b17c6edadc809dd780669719b2f8fa6a0e.jpg";